import { Link } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses.js';
import type { JSX } from 'react';

export const InfoBanner = ({
  title,
  description,
  buttonText,
  buttonTo,
}: {
  title: string;
  description: string;
  buttonText: string;
  buttonTo: string;
}): JSX.Element => (
  <section className="of-public-mobile-voice-subscriptions__info-banner">
    <h2>{title}</h2>
    <p>{description}</p>
    <Link
      className={`${dsClass.LINK} ${dsClass.LINK_BUTTON_COLOR_LIGHT} ${dsClass.LINK_BUTTON_SIZE_L} ${dsClass.LINK_STYLE_LINK_BUTTON}`}
      to={buttonTo}
    >
      {buttonText}
    </Link>
  </section>
);
